var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"text","placeholder":_vm.placeholder,"name":_vm.name},on:{"input":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }